import PropertyCard from './PropertyCard';
import { ArrowLeftIcon, ArrowRightIcon } from './PropertyIcons';

const properties = [
  {
    id: 1,
    image: 'https://api.builder.io/api/v1/image/assets/TEMP/b00c2a0c3cf044e1f60e82334c1a0613c74c8cef?width=864',
    title: 'Seaside Serenity Villa',
    description: 'A stunning 4-bedroom, 3-bathroom villa in a peaceful suburban neighborhood',
    bedrooms: 4,
    bathrooms: 3,
    propertyType: 'Villa',
    price: '$550,000',
  },
  {
    id: 2,
    image: 'https://api.builder.io/api/v1/image/assets/TEMP/b81f05ac6ed9002cd0344dbce8ab9a0fbaba5945?width=864',
    title: 'Metropolitan Haven',
    description: 'A chic and fully-furnished 2-bedroom apartment with panoramic city views',
    bedrooms: 2,
    bathrooms: 2,
    propertyType: 'Villa',
    price: '$550,000',
  },
  {
    id: 3,
    image: 'https://api.builder.io/api/v1/image/assets/TEMP/7142bfa881e733aafbb3ebab25a94bd3393a274c?width=864',
    title: 'Rustic Retreat Cottage',
    description: 'An elegant 3-bedroom, 2.5-bathroom townhouse in a gated community',
    bedrooms: 3,
    bathrooms: 3,
    propertyType: 'Villa',
    price: '$550,000',
  },
];

export default function FeaturedProperties() {
  return (
    <div id="featured-properties-section" className="w-full lg:border-t bg-white py-16 md:py-20 lg:py-24 px-6 md:px-12 lg:px-16 xl:px-20 md:-mt-16 lg:-mt-20 relative z-0">
      <div className="max-w-6xl mx-auto flex flex-col gap-12 lg:gap-16 pt-12 md:pt-16 lg:pt-20">
        {/* Header Section */}
        <div className="flex flex-col lg:flex-row items-start lg:items-end gap-4 lg:gap-16">
          <div className="flex-1 flex flex-col gap-2">
            <div className="relative">
              <h1 className="text-2xl md:text-3xl lg:text-4xl font-semibold leading-[150%] text-primary">
                Featured Properties
              </h1>
            </div>
            <p className="text-sm md:text-base font-normal leading-[150%] text-black">
              Explore our handpicked selection of featured properties. Each listing offers exceptional homes and investments available through Alkina Realty.
            </p>
          </div>
          
          <button className="px-4 py-2.5 bg-[var(--color-primary)] hover:bg-[var(--color-primary)]/90 transition-colors whitespace-nowrap">
            <span className="text-sm font-medium leading-[150%] text-white">
              View All Properties
            </span>
          </button>
        </div>
        
        {/* Properties Grid */}
        <div className="flex flex-col gap-6">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-5 lg:gap-6">
            {properties.map((property) => (
              <PropertyCard key={property.id} {...property} />
            ))}
          </div>
          
          {/* Pagination */}
          <div className="flex items-center justify-between pt-3 border-t border-gray-300">
            <div className="text-sm md:text-base font-medium leading-[150%]">
              <span className="text-primary">01</span>
              <span className="text-primary"> of 60</span>
            </div>
            
            <div className="flex items-center gap-2">
              <button 
                className="p-1.5 md:p-2 border border-gray-300 hover:bg-gray-100 transition-colors"
                aria-label="Previous page"
              >
                <ArrowLeftIcon className="w-4 h-4 md:w-6 md:h-6" />
              </button>
              <button 
                className="p-1.5 md:p-2 border border-gray-300 bg-gray-100 hover:bg-gray-200 transition-colors"
                aria-label="Next page"
              >
                <ArrowRightIcon className="w-4 h-4 md:w-6 md:h-6" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}


